import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconYoutube = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <path
          d="M9.99565 5.10059C9.99565 5.10059 5.62008 5.10059 4.52187 5.38595C3.93386 5.55025 3.44967 6.03445 3.28537 6.63112C3.00001 7.72933 3 10.0036 3 10.0036C3 10.0036 3.00001 12.2866 3.28537 13.3675C3.44967 13.9642 3.92521 14.4397 4.52187 14.604C5.62873 14.898 9.99565 14.898 9.99565 14.898C9.99565 14.898 14.3799 14.898 15.4781 14.6127C16.0747 14.4484 16.5503 13.9815 16.7059 13.3762C16.9999 12.2866 17 10.0123 17 10.0123C17 10.0123 17.0086 7.72933 16.7059 6.63112C16.5503 6.03445 16.0747 5.55891 15.4781 5.40326C14.3799 5.1006 9.99565 5.10059 9.99565 5.10059V5.10059ZM8.60341 7.90237L12.244 10.0036L8.60341 12.0962V7.90237V7.90237Z"
          fill="#FF0000"
        />
      </SvgIcon>
    );
  })
);
